import { parseDomain } from 'helpers/parseDomain';

import {
  Input,
  Inject,
  OnInit,
  Output,
  Component,
  EventEmitter,
} from 'ng-metadata/core';

import { CartService } from 'services/cart.service';
import { DialogService } from 'services/dialog.service';
import { ProductService } from 'services/product.service';
import { EtomsService } from 'services/etoms.service';

import cartItemHtml from './cart-item.html';
import './cart-item.scss';

@Component({
  selector: 'gw-cart-item',
  template: cartItemHtml,
})
export class CheckoutCartItemComponent implements OnInit {
  public passportAddons;
  public outboundOptions;
  public processingOptions;
  public state = {
    loading: false,
    outbound: null,
  };
  public etomsEnabled: Boolean = false;
  public cart;

  @Input() index;
  @Input() firstItem;
  @Input() options;
  @Input() product;
  @Input() traveler;
  @Input() orderItem;
  @Input() productType: string;
  @Output() onDelete = new EventEmitter();
  @Output() onUpdate = new EventEmitter();

  constructor(
    @Inject('$filter') private $filter,
    @Inject(CartService) private cartService: CartService,
    @Inject(DialogService) private dialogService: DialogService,
    @Inject(ProductService) private productService: ProductService,
    @Inject(EtomsService) private etomsService: EtomsService,
  ) { }

  /**
   * Component init hook
   */
  ngOnInit() {
    this.cart = this.cartService.getCart();
    this.etomsEnabled = this.etomsService.enabled();
    switch (this.productType) {
      case 'visa':
        this.getVisaProcessingOptions();
        break;
      case 'passport':
        this.getPassportProcessingOptions();
        break;
    }

    this.productService
      .getOutboundOptions()
      .then((options) => {
        this.outboundOptions = options;

        if (!this.orderItem.outbound && this.orderItem.requireShipping) {
          this.updateProcessing();
        }
      });
  }

  isMailaway(product, options) {
    // Determine if mailaways
    if (this.cartService.determineMailaway(product, options)) {
      return true;
    }

    return false;
  }

  async getVisaProcessingOptions() {
    try {
      const response: any = await this.productService
        .confirmProductRequirement(
          this.orderItem.productId,
          this.traveler.citizenship,
          this.traveler.residency,
        );

      const productDetails = response.data;
      const options = this.etomsEnabled
        ? productDetails.options[this.options.entries][this.options.validity]
        : productDetails.options[this.options.entries];

      this.processingOptions = options
        .map(this.cartService.mapVisaProcessingOptions.bind(this));
    } catch (e) {
      throw e;
    }
  }

  async getPassportProcessingOptions() {
    try {
      const response = await this.productService.getPassportOptions();

      if (this.product.subtype !== 'passport-renewal') {
        const i = response.options.findIndex(opt => opt.renewal);
        if (i > -1) response.options.splice(i, 1);
      }

      this.processingOptions = response.options;
      this.passportAddons = response.addons;
    } catch (e) {
      throw e;
    }
  }

  buildOptionLabel(option) {
    let label = `${option.label}`;

    if (this.orderItem.type === 'visa') {
      return label;
    }

    label += ': ';

    if (option.daysRange === '1') {
      label += '24 Hours';
    } else {
      label += `${option.daysRange} Business Days`;
    }

    return label;
  }

  updateProcessing() {
    const option = this.processingOptions
      .find(opt => opt.uuid === this.orderItem.optionsId);

    if (this.isMailaway(this.product, option)) {
      let optionId = 'usps_priority_3_days';

      if (this.orderItem.requireShipping) {
        this.orderItem.outbound = this.outboundOptions
          .find(opt => opt.value === optionId);
      }
    }

    this.onUpdate.emit(option);
  }

  removeItem() {
    this.onDelete.emit({});
  }

  getSubtotal() {
    let subtotal = this.cartService.getSubtotalNew(this.orderItem);
    if (this.firstItem) {
      subtotal += this.cartService.getShippingTotal(this.orderItem);
    }
    return this.$filter('currency')(subtotal);
  }

  determineGovFee() {
    const fee = this.cartService
      .determineGovFee(this.product, this.orderItem.addons, this.options);

    return this.$filter('currency')(fee);
  }

  async toggleAddon(chosenAddon) {
    const i = this.orderItem.addons.findIndex(addon => addon.uuid === chosenAddon.uuid);

    if (i > -1) {
      this.orderItem.addons.splice(i, 1);
    } else {
      this.orderItem.addons.push(chosenAddon);
    }

    try {
      await this.cartService.saveCart();
    } catch (e) {
      throw e;
    }
  }

  addonExists(addonId) {
    return this.orderItem.addons.findIndex(addon => addon.uuid === addonId) > -1;
  }

  /**
   * Toggle the addon selection
   *
   * @param key
   */
  toggleAddonSelection(key) {
    if (this.isAddonSelected(key)) {
      this.orderItem.addons = this.orderItem.addons.filter(addon => addon !== key);
    } else {
      this.orderItem.addons.push(key);
    }

    if (key === this.product.addons.embassy_fee) {
      this.orderItem.chargeEmbassyFee = !this.orderItem.chargeEmbassyFee;
    }
  }

  /**
   * Check if the addOn is already selected
   *
   * @param key
   */
  isAddonSelected(key) {
    return this.orderItem.addons.find(addOn => addOn === key) !== undefined;
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/checkout/cart/item/cart-item.component.ts